import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import { UserMinus } from "react-feather";
import { useEffect, useRef, useState } from "react";
import { useMessage } from "../../global-components/src";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { errorMessage } from "../../utils/TextManagerTwo";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { Ban } from "../../types";
import UserSearch from "../Settings/SearchScreen/User/User";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { UserSearchLoadin } from "../Settings/SearchScreen/User/UserSearchLoading";
import { useParams } from "react-router-dom";

const UsersByIp = () => {
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [bans, setBans] = useState<Ban[] | null>(null);
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(() => { return 1; });
    const { token } = useAuth();
    const { ip } = useParams();

    const loadData = async (newPage?: number) => {
        const currentPage = newPage ?? page + 1; // Usa newPage se fornecido, senão incrementa
        const url = PACOCA_API_URL + `/moderators/users-by-ip/${ip}?page=${currentPage}`;

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.users.length > 0) {
                setBans((prevData) => [...(prevData || []), ...data.users]);
            } else {
                setEnd(true);
            }

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if(!loading && !end) loadData(page);
    }, [page]);
    

    useEffect(() => {
        const modalBody = document.getElementById("modal-comments-body");

        const handleScroll = () => {
            if (!modalBody) return;
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if ((scrollTop + clientHeight >= scrollHeight - 50) && !end && !loading) {
                setPage((prevPage) => prevPage + 1); // Agora a página é atualizada antes da requisição
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
            window.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
                window.removeEventListener("scroll", handleScroll);
            }
        };
    }, [end, loading]);
    
    return (
        <>
            <Screen paddingTopTitle={true} title={`Usuários por IP: ${ip}`}>
                <Helmet>
                    <title>Paçoca - Usuários por IP: {ip}</title>
                </Helmet>

                <>
                    {bans?.map((ban, index) => {
                        return (
                            <UserSearch clasImgAccount="img-list-chat" hideFollowUser key={index} user={ban?.user} />
                        );
                    })}

                    <UserSearchLoadin loading={loading}/>

                    {(!bans && !loading) || (bans && !bans.length && !loading) ? (
                        <div className="user-select-none row mt-5">
                            <span className="span-empty">
                                <UserMinus className="icon-empty" />
                                <h3 className="w-100 text-center">Nenhum usuário encontrado</h3>
                            </span>
                        </div>
                    ): null}
                    
                    <p ref={endOfListRef}></p>
                </>
            </Screen>
        </>
    );
};

export default UsersByIp;